import { createFileRoute } from '@tanstack/react-router';
import { legacyRedirect } from './-components';

// The old `journeys` URL for Collections. The page lives at `/workspaces/:workspaceId/collections`.
export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/importing',
)({
  beforeLoad: legacyRedirect('/workspaces/:workspaceId/collections/:collectionId/importing'),
});
